<template>
  <section>
    <BaseForm>
      <BaseDatepicker
        :label="$t('StartDate')"
        v-model="form.startDate"
        validate="required"
        no-margin
        @input="generate" />
      <p>
        <IconWarning />
        Si aucune date n'est sélectionnée,
        la date de début va être le dernier 1er décembre passé.
      </p>
      <BaseDatepicker
        :label="$t('EndDate')"
        v-model="form.endDate"
        validate="required"
        no-margin
        @input="generate" />
      <p>
        <IconWarning />
        Si aucune date n'est sélectionnée,
        la date de fin va être aujourd'hui.
      </p>
    </BaseForm>
  </section>
</template>
<script>
import moment from 'moment';

export default {
  components: {
  },
  data() {
    return {
      form: {
        startDate: null,
        endDate: null,
      },
    };
  },
  created() {
    if (!this.form.startDate) {
      if (moment().month() === 12) {
        this.form.startDate = moment(`${moment().year()}-12-01`, 'YYYY-MM-DD').toDate();
      } else {
        this.form.startDate = moment(`${moment().subtract(1, 'years').year()}-12-01`, 'YYYY-MM-DD').toDate();
      }
    }

    if (!this.form.endDate) {
      this.form.endDate = moment().toDate();
    }
    this.generate();
  },
  methods: {
    async generate() {
      this.$emit('submit', {
        user: this.form.user,
        startDate: moment(this.form.startDate).format('YYYY-MM-DD'),
        endDate: moment(this.form.endDate).format('YYYY-MM-DD'),
      });
    },
  },
};
</script>
